// extracted by mini-css-extract-plugin
export default {"wrapper":"Home_wrapper__Wiz25","footer":"Home_footer__GJWyH"};